import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Textarea } from "formsy-react-components";

const CallApprovalNotificationForm = ({
  onClose,
  onCancel,
  callApprovalToNotify,
  save
}) => {
  const ref = useRef();
  const [enabled, setEnabled] = useState(false);
  const [saving, setSaving] = useState(false);

  const enable = () => {
    setEnabled(true);
  };
  const disable = () => {
    setEnabled(false);
  };
  const submit = async (model) => {
    setSaving(true);
    await save(callApprovalToNotify._id, model.body);
    setSaving(false);
    onClose();
  };

  return (
    <Formsy
      ref={ref}
      className="vertical form"
      onValidSubmit={submit}
      onValid={enable}
      onInvalid={disable}
    >
      <Row>
        <Col md={12}>
          <Textarea
            required
            name="body"
            label="Message"
            validations={{ maxLength: 3000 }}
            validationErrors={{
              maxLength: "You can not type in more than 3000 characters"
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} xs={12} className="footer">
          <button className="btn btn-cancel" type="button" onClick={onCancel}>
            Cancel
          </button>
          <input
            className="btn btn-success"
            type="submit"
            disabled={!enabled || saving}
            value={saving ? "Sending... " : "Send"}
          />
        </Col>
      </Row>
    </Formsy>
  );
};
CallApprovalNotificationForm.propTypes = {
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  callApprovalToNotify: PropTypes.object,
  save: PropTypes.func
};
export default CallApprovalNotificationForm;
